export enum RouterRequestActionType {
  RouterRequest = 'ROUTER_REQUEST',
  RouterBackRequest = 'ROUTER_BACK_REQUEST',
  RouterForwardRequest = 'ROUTER_FORWARD_REQUEST',
  RouterRequestFulfilled = 'ROUTER_REQUEST_FULFILLED',
  RouterRequestRejected = 'ROUTER_REQUEST_REJECTED',
  RouterRequestError = 'ROUTER_REQUEST_ERROR',
}
